///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/product-variants.collection.ts"/>

module Meevo.Components.Controls.SmartMover {
    import Variant = Model.Variant;

    export class CSEProductVariantsCollection extends ProductVariantsCollection implements IApiCollection<Variant> {
        protected get smartMoverHiddenValue(): SmartMoverHiddenValue {
            return SmartMoverHiddenValue.EmptyArray;
        }
    }
}
